/* ============================================================
   ARCADE2TV-XR MAX — product page engine
   Vanilla, no dependencies required. Uses the theme's global
   Swiper when present, with a scroll-snap fallback otherwise.
   ============================================================ */
(function () {
  "use strict";
  var root = document.getElementById("AXRPDP");
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- sticky-context repair (theme wrappers kill position:sticky) ---------- */
  function unbreakSticky() {
    for (var el = root.parentElement; el; el = el.parentElement) {
      var cs = getComputedStyle(el);
      var rootish = el === document.body || el === document.documentElement;
      if (cs.overflowX === "hidden") el.style.setProperty("overflow-x", "clip", "important");
      if (cs.overflowY === "hidden" && !rootish) el.style.setProperty("overflow-y", "clip", "important");
    }
  }
  unbreakSticky();
  window.addEventListener("load", unbreakSticky);

  /* ---------- reveal on scroll ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
    $$("[data-reveal]").forEach(function (el, i) {
      el.style.transitionDelay = ((i % 3) * 90) + "ms";
      io.observe(el);
    });
  } else {
    $$("[data-reveal]").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- count-up stats ---------- */
  var strip = $(".numgrid");
  if (strip && "IntersectionObserver" in window) {
    var done = false;
    new IntersectionObserver(function (es, obs) {
      es.forEach(function (e) {
        if (!e.isIntersecting || done) return;
        done = true; obs.disconnect();
        $$(".num b[data-count]", strip).forEach(function (el) {
          var target = parseFloat(el.getAttribute("data-count")) || 0;
          var suffix = el.getAttribute("data-suffix") || "";
          if (reduced) { el.textContent = target + suffix; return; }
          var t0 = performance.now();
          (function tick() {
            var k = Math.min(1, (performance.now() - t0) / 900);
            k = 1 - Math.pow(1 - k, 3);
            el.textContent = Math.round(target * k) + suffix;
            if (k < 1) requestAnimationFrame(tick);
          })();
        });
      });
    }, { threshold: 0.4 }).observe(strip);
  }

  /* ---------- cursor-follow glow on red buttons ---------- */
  $$(".btn-red").forEach(function (b) {
    b.addEventListener("pointermove", function (e) {
      var r = b.getBoundingClientRect();
      b.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
      b.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
    });
  });

  /* ---------- gallery ---------- */
  var stageEl = $(".pdp-stage .swiper");
  var thumbs = $$(".pdp-thumb");
  var swiper = null;
  function syncThumbs(idx) {
    thumbs.forEach(function (t, i) {
      t.classList.toggle("on", i === idx);
      if (i === idx && t.scrollIntoView) {
        try { t.scrollIntoView({ block: "nearest", inline: "nearest", behavior: reduced ? "auto" : "smooth" }); } catch (e) {}
      }
    });
    // pause videos on hidden slides, play visible
    $$(".pdp-stage video").forEach(function (v) {
      var slide = v.closest(".swiper-slide");
      var active = slide && slide.classList.contains("swiper-slide-active");
      if (active) { v.play && v.play().catch(function () {}); }
      else { v.pause && v.pause(); }
    });
  }
  if (stageEl && window.Swiper) {
    swiper = new window.Swiper(stageEl, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      speed: reduced ? 0 : 520,
      allowTouchMove: true,
      navigation: { nextEl: "#AXRPDP .pdp-arrow.next", prevEl: "#AXRPDP .pdp-arrow.prev" },
      on: { slideChange: function () { syncThumbs(this.activeIndex); } }
    });
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () { swiper.slideTo(i); });
    });
    syncThumbs(0);
  } else if (stageEl) {
    // fallback: show/hide slides manually
    var slides = $$(".swiper-slide", stageEl), cur = 0;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.style.display = k === cur ? "flex" : "none";
        s.classList.toggle("swiper-slide-active", k === cur);
      });
      syncThumbs(cur);
    }
    var pa = $(".pdp-arrow.prev"), na = $(".pdp-arrow.next");
    pa && pa.addEventListener("click", function () { show(cur - 1); });
    na && na.addEventListener("click", function () { show(cur + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { show(i); }); });
    show(0);
  }

  /* ---------- variant selection ---------- */
  var form = document.getElementById("axr-product-form");
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var priceEl = $("[data-pdp-price]");
  var wasEl = $("[data-pdp-was]");
  var saveEl = $("[data-pdp-save]");
  var shipEl = $("[data-pdp-shipnote]");
  var atcBtn = $("[data-pdp-atc]");
  var bbPrice = $("[data-buybar-price]");
  var bbVar = $("[data-buybar-variant]");
  var cards = $$(".vcard[data-variant-id]");

  function money(cents) {
    var v = cents / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? v.toFixed(0) : v.toFixed(2);
    return "$" + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function selectCard(card, pushUrl) {
    if (!card || card.getAttribute("aria-disabled") === "true") return;
    cards.forEach(function (c) {
      var on = c === card;
      c.setAttribute("aria-checked", on ? "true" : "false");
      c.tabIndex = on ? 0 : -1;
      var r = c.querySelector(".vcard-radio");
      if (r) r.checked = on;
    });
    var vid = card.getAttribute("data-variant-id");
    var price = parseInt(card.getAttribute("data-price"), 10);
    var compare = parseInt(card.getAttribute("data-compare"), 10) || 0;
    var avail = card.getAttribute("data-available") === "true";
    var title = card.getAttribute("data-variant-title") || "";
    if (idInput) idInput.value = vid;
    if (priceEl) priceEl.textContent = money(price);
    if (wasEl) {
      if (compare > price) { wasEl.textContent = money(compare); wasEl.style.display = ""; }
      else { wasEl.style.display = "none"; }
    }
    if (saveEl) {
      if (compare > price) { saveEl.textContent = "Save " + money(compare - price) + " at pre-order"; saveEl.style.display = ""; }
      else { saveEl.style.display = "none"; }
    }
    if (shipEl) {
      var note = card.getAttribute("data-shipnote");
      if (note) shipEl.innerHTML = note;
    }
    if (atcBtn) {
      atcBtn.disabled = !avail;
      var lbl = atcBtn.querySelector(".btn-label");
      if (lbl) lbl.textContent = avail ? (atcBtn.getAttribute("data-label-preorder") || "Pre-order now") : (atcBtn.getAttribute("data-label-soldout") || "Sold out");
    }
    if (bbPrice) bbPrice.textContent = money(price);
    if (bbVar) bbVar.textContent = title;
    // keep the URL shareable on the real product page
    if (pushUrl && root.getAttribute("data-on-max-product") === "true" && window.history && history.replaceState) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", vid);
        history.replaceState({}, "", u.toString());
      } catch (e) {}
    }
  }
  cards.forEach(function (c) {
    c.addEventListener("click", function () { selectCard(c, true); });
    c.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") { e.preventDefault(); selectCard(c, true); }
      if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); var n = cards[(cards.indexOf(c) + 1) % cards.length]; selectCard(n, true); n.focus(); }
      if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); var p = cards[(cards.indexOf(c) - 1 + cards.length) % cards.length]; selectCard(p, true); p.focus(); }
    });
  });
  // tilt on hover (desktop pointers only)
  if (window.matchMedia("(hover:hover)").matches && !reduced) {
    cards.forEach(function (c) {
      c.addEventListener("pointermove", function (e) {
        var r = c.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -3.5;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 3.5;
        c.style.transform = "perspective(700px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg)";
      });
      c.addEventListener("pointerleave", function () { c.style.transform = ""; });
    });
  }
  // initial state from the checked card
  var init = cards.filter(function (c) { return c.getAttribute("aria-checked") === "true"; })[0] || cards[0];
  if (init) selectCard(init, false);

  /* ---------- quantity ---------- */
  var qtyIn = $(".pdp-qty input");
  $$(".pdp-qty button").forEach(function (b) {
    b.addEventListener("click", function () {
      if (!qtyIn) return;
      var v = parseInt(qtyIn.value, 10) || 1;
      v += b.getAttribute("data-step") === "up" ? 1 : -1;
      qtyIn.value = Math.max(1, Math.min(99, v));
    });
  });

  /* ---------- form submit: loading state ---------- */
  if (form) {
    form.addEventListener("submit", function () {
      if (atcBtn && !atcBtn.disabled) atcBtn.classList.add("is-loading");
    });
  }

  /* ---------- sticky buy bar ---------- */
  var buybar = $(".buybar");
  var buyBox = $(".pdp-buy");
  var finale = $(".finale");
  if (buybar && buyBox) {
    var update = function () {
      var r = buyBox.getBoundingClientRect();
      var passed = r.bottom < 0;
      var nearEnd = false;
      if (finale) {
        var fr = finale.getBoundingClientRect();
        nearEnd = fr.top < window.innerHeight * 0.75;
      }
      buybar.classList.toggle("on", passed && !nearEnd);
      buybar.setAttribute("aria-hidden", passed && !nearEnd ? "false" : "true");
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ---------- detail rail nav + lightbox ---------- */
  var rail = $(".rail");
  if (rail) {
    var step = function () {
      var cardsR = $$(".rail-card", rail);
      return cardsR.length > 1 ? cardsR[1].offsetLeft - cardsR[0].offsetLeft : 380;
    };
    var rp = $("[data-rail-prev]"), rn = $("[data-rail-next]");
    rp && rp.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
    rn && rn.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
  }
  var lbItems = $$("[data-lightbox-src]");
  if (lbItems.length) {
    var lb = document.createElement("div");
    lb.id = "AXRPDP-lightbox";
    lb.innerHTML = '<button class="lb-x" aria-label="Close">&#10005;</button>' +
      '<button class="lb-arrow lb-prev" aria-label="Previous">&#8249;</button>' +
      '<img alt="">' +
      '<button class="lb-arrow lb-next" aria-label="Next">&#8250;</button>' +
      '<div class="lb-cap"></div>';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector("img"), lbCap = lb.querySelector(".lb-cap"), lbIdx = 0;
    function openLb(i) {
      lbIdx = (i + lbItems.length) % lbItems.length;
      var it = lbItems[lbIdx];
      lbImg.src = it.getAttribute("data-lightbox-src");
      lbImg.alt = it.getAttribute("data-lightbox-alt") || "";
      lbCap.textContent = it.getAttribute("data-lightbox-cap") || "";
      lb.classList.add("on");
      document.body.style.overflow = "hidden";
    }
    function closeLb() { lb.classList.remove("on"); document.body.style.overflow = ""; }
    lbItems.forEach(function (it, i) {
      it.addEventListener("click", function () { openLb(i); });
      it.addEventListener("keydown", function (e) { if (e.key === "Enter") openLb(i); });
    });
    lb.querySelector(".lb-x").addEventListener("click", closeLb);
    lb.querySelector(".lb-prev").addEventListener("click", function () { openLb(lbIdx - 1); });
    lb.querySelector(".lb-next").addEventListener("click", function () { openLb(lbIdx + 1); });
    lb.addEventListener("click", function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("on")) return;
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowLeft") openLb(lbIdx - 1);
      if (e.key === "ArrowRight") openLb(lbIdx + 1);
    });
  }

  /* ---------- spinner rotates with scroll ---------- */
  var disc = $(".spin-disc");
  if (disc && !reduced) {
    var vel = 0, rot = 0, lastY = window.scrollY;
    (function spinLoop() {
      requestAnimationFrame(spinLoop);
      var y = window.scrollY;
      vel += (y - lastY) * 0.4; lastY = y;
      vel *= 0.93; rot += vel * 0.05;
      disc.style.transform = "rotate(" + rot.toFixed(2) + "deg)";
    })();
  }

  /* ---------- smooth in-page anchors ---------- */
  $$('a[href^="#"]', root).forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" }); }
    });
  });
})();
